import { IconProps } from '../../utils/icon';
import { IconBase } from '../../utils/IconBase';

/**
 * 
 * @param param0 // <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.4375 9.5625H4.6875C4.52813 9.5625 4.39456 9.50856 4.28681 9.40069C4.17894 9.29281 4.125 9.15919 4.125 8.99981C4.125 8.84031 4.17894 8.70675 4.28681 8.59913C4.39456 8.49138 4.52813 8.4375 4.6875 8.4375H8.4375V4.6875C8.4375 4.52813 8.49144 4.39456 8.59931 4.28681C8.70719 4.17894 8.84081 4.125 9.00019 4.125C9.15969 4.125 9.29325 4.17894 9.40088 4.28681C9.50863 4.39456 9.5625 4.52813 9.5625 4.6875V8.4375H13.3125C13.4719 8.4375 13.6054 8.49144 13.7132 8.59931C13.8211 8.70719 13.875 8.84081 13.875 9.00019C13.875 9.15969 13.8211 9.29325 13.7132 9.40088C13.6054 9.50863 13.4719 9.5625 13.3125 9.5625H9.5625V13.3125C9.5625 13.4719 9.50856 13.6054 9.40069 13.7132C9.29281 13.8211 9.15919 13.875 8.99981 13.875C8.84031 13.875 8.70675 13.8211 8.59913 13.7132C8.49138 13.6054 8.4375 13.4719 8.4375 13.3125V9.5625Z" fill="#4C5053"/>
</svg>
 */
const PlusLine = ({ width = 18, height = 18, ...props }: IconProps) => {
  return (
    <IconBase
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      paths={[
        {
          d: 'M8.4375 9.5625H4.6875C4.52813 9.5625 4.39456 9.50856 4.28681 9.40069C4.17894 9.29281 4.125 9.15919 4.125 8.99981C4.125 8.84031 4.17894 8.70675 4.28681 8.59913C4.39456 8.49138 4.52813 8.4375 4.6875 8.4375H8.4375V4.6875C8.4375 4.52813 8.49144 4.39456 8.59931 4.28681C8.70719 4.17894 8.84081 4.125 9.00019 4.125C9.15969 4.125 9.29325 4.17894 9.40088 4.28681C9.50863 4.39456 9.5625 4.52813 9.5625 4.6875V8.4375H13.3125C13.4719 8.4375 13.6054 8.49144 13.7132 8.59931C13.8211 8.70719 13.875 8.84081 13.875 9.00019C13.875 9.15969 13.8211 9.29325 13.7132 9.40088C13.6054 9.50863 13.4719 9.5625 13.3125 9.5625H9.5625V13.3125C9.5625 13.4719 9.50856 13.6054 9.40069 13.7132C9.29281 13.8211 9.15919 13.875 8.99981 13.875C8.84031 13.875 8.70675 13.8211 8.59913 13.7132C8.49138 13.6054 8.4375 13.4719 8.4375 13.3125V9.5625Z',
          fill: props.fill || '#4C5053',
        },
      ]}
      {...props}
    />
  );
};

export default PlusLine;
